// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { AuthenticateStatus } from './authenticateStatus.js';
import type { IAuthenticationData } from './iAuthenticationData.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class IAuthenticationResponseModel {
    'status': AuthenticateStatus;
    'success': boolean;
    'messages': Array<string>;
    'data': IAuthenticationData | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof IAuthenticationResponseModel>> = [
        {
            "name":     "status",
            "baseName": "status",
            "type":     "AuthenticateStatus"
        },
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "IAuthenticationData"
        },
    ];

    static getAttributeTypeMap() {
        return IAuthenticationResponseModel.attributeTypeMap;
    }
}
